import moment from 'moment'

export const getToday = (withoutTime: boolean = false) =>
    withoutTime ? moment(moment().format('L')) : moment()
